// extracted by mini-css-extract-plugin
export default {"ListePriorite":"SelectPrioriteDemande_ListePriorite__qmY3Y","PrioriteDemande":"SelectPrioriteDemande_PrioriteDemande__L6Iqz","Delai":"SelectPrioriteDemande_Delai__BttfF"};